import { render, staticRenderFns } from "./Content_Generator.vue?vue&type=template&id=4b0cd9c6&scoped=true&"
import script from "./Content_Generator.vue?vue&type=script&lang=js&"
export * from "./Content_Generator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0cd9c6",
  null
  
)

export default component.exports